import { Component } from "react";
import { withSearch } from "@elastic/react-search-ui";
import axios from "axios";

class TopBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: this.props.config,
      bannerTopList: [],      
      languageId: this.props.languageId,
      isMounted: false,
      jwt: this.props.jwt,
      api_url: this.props.api_url,
    };
  }

  
  getTopBanners = () => {
    var manufacturer_name = "";
    let keys = [];

    Object.keys(this.props.filters).length > 0 &&
      Object.keys(this.props.filters).map((key) => {
        keys.push(this.props.filters[key].field);
        if (
          this.props.filters[key].field == "manufacturer" &&
          this.props.filters[key].values.length > 0
        ) {
          manufacturer_name = this.props.filters[key].values[0];
        }
      });

    if (manufacturer_name != "") {
       let newURL = this.state.api_url+'/top-banners?manufacturer_name=' + manufacturer_name + '&language_id=' + this.state.languageId;
            const cartProducts = axios.get(newURL, {
              headers: { 
                "Content-type": "application/json",
                "Authorization": this.state.jwt,        
              },
              method: "GET",
            }).then((response) => {
              if (response.status === 200) {
                let banners = response.data.data;
                
                
                if (banners && banners.length > 0) {
                  this.setState({ bannerTopList: banners });
                }
              }
            }).catch((error) => {
              console.error("Error fetching top banners:", error);
            });
    } else {
      this.setState({ bannerTopList: [] });
    }


    if (!keys.includes("manufacturer") && this.state.isMounted) {
      this.setState({ bannerTopList: [] });
    }
  };

  componentWillUnmount() {
    this.setState({ isMounted: false });
  }

  arraysAreEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    const sortedArr1 = arr1.map((obj) => JSON.stringify(obj)).sort();
    const sortedArr2 = arr2.map((obj) => JSON.stringify(obj)).sort();

    for (let i = 0; i < arr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }
    return true;
  }

  componentDidMount() {
    this.setState({ isMounted: true }, () => {
      this.getTopBanners();
    });
  }

  componentDidUpdate(prevProps) {
    console.log("Updated");
    if (!this.arraysAreEqual(this.props.filters, prevProps.filters)) {
      this.getTopBanners();
    }
  }
  

  render() {

    // Función manejadora del clic
    const handleBannerClick = (link) => {
      if(link && link.trim() !== '') {
        window.open(link.trim(), '_blank');
      }
    };
  
    const { bannerTopList } = this.state;
    const currentImage = bannerTopList[Math.floor(Math.random() * bannerTopList.length)];
    
    return (
      <div id="bannertop" className="banner-top"
      style={{cursor: 'pointer', ':hover': { opacity: '0.9' } }}
      onClick={() => handleBannerClick(currentImage?.link)}>
        <div className="row">
          <div className="col-md-12">
            {bannerTopList && (            
              <img
                loading="lazy"
                src={
                  currentImage?.image
                }
              ></img>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withSearch(({ filters }) => ({
  filters,
}))(TopBanner);
